import ProductModel from './product.model'
import BaseModel from './base.model'
export default class RechargeModel extends BaseModel {

  products = [];
  message = null;
  has_error = null;
  data = null;
  mins = null;
  sms = null;
  whatsApp = null;    
  fixedLte = null;    
  msisdn = null; 

  constructor (data) {
    super();
    if (this.isEmpty(data)) return this;        
    this.products = data.products || [];
    this.data = new ProductModel(data.data);
    this.mins = new ProductModel(data.mins);
    this.sms = new ProductModel(data.sms);
    this.whatsApp = new ProductModel(data.whatsApp);    
    this.fixedLte = new ProductModel(data.fixedLte);    
    this.msisdn = data.msisdn;    
    this.message = data.message;
    this.has_error = data.has_error;
  }

  formatedMsisdn() {
    if(this.isEmpty(this.msisdn) && this.msisdn.indexOf('0') == 0) return null;
    return this.msisdn.replace('0','27');
  }

  getSelectedProducts() {
    var self = this;
    var response = [];
        if(!this.isEmpty(self.data)) response.push(self.data.id);
        if(!this.isEmpty(self.mins)) response.push(self.mins.id);
        if(!this.isEmpty(self.sms)) response.push(self.sms.id);
        if(!this.isEmpty(self.whatsApp)) response.push(self.whatsApp.id);
        if(!this.isEmpty(self.fixedLte)) response.push(self.fixedLte.id);
    return response;
  }
}
